import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import { goToStore } from './goToStore'

export const goToHome = (
  router: AppRouterInstance,
  params?: URLSearchParams
) => {
  const storeId = getCSRCookieData('_IL-storeId')
  const breakpointCode = getCSRCookieData('_IL-breakpointCode')
  const storeReference = getCSRCookieData('_IL-storeReference')
  const canGoToStore = storeId && breakpointCode && storeReference

  if (canGoToStore) {
    goToStore(router, {
      store: {
        code: storeReference,
        id: storeId,
      },
      breakpoint: breakpointCode,
    })
    return
  }
  const queryString = params?.toString()
  const url = queryString ? `/?${queryString}` : '/'

  router.push(url)
}
